export const CACHE_VERSION = '1'
export const PERSIST_KEY = `acespace`
export const PERSIST_TIMEOUT = 15000
export const PERSIST_STORAGE_KEY = `${PERSIST_KEY}_${CACHE_VERSION}`
